import UserForm from '@/views/App/User/BasicInformation/Form.vue';
import UserBasicInfo from '@/views/App/User/BasicInformation/BsicInformation.vue';
import UserList from '@/views/App/User/List.vue';
import UserQualificationList from '@/views/App/User/Qualification/List.vue';
import FurtherEducationList from '@/views/App/User/FurtherEducation/List.vue';
import StudentWorkingDaysList from '@/views/App/User/StudentWorkingDays/List.vue';

const routesUser = [
    {
        path: 'list',
        name: 'userList',
        component: UserList
    },
    {
        path: 'form/:id?',
        name: 'userForm',
        component: UserForm
    },
    {
        path: 'basic-info/:id',
        name: 'userBasicInfo',
        component: UserBasicInfo
    },
    // {
    //     path: 'user-profile',
    //     name: 'userProfile',
    //     component: UserProfile
    // },
    {
        path: 'qualification-list/:id',
        name: 'userQualificationList',
        component: UserQualificationList
    },
    {
        path: 'further-education-list/:id',
        name: 'furtherEducationList',
        component: FurtherEducationList
    },
    {
        path: 'student-working-days-list/:id',
        name: 'studentWorkingDaysList',
        component: StudentWorkingDaysList
    },
];

export default routesUser;